import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBridge: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBridge"><Path d="M12 4.5C16.4183 4.5 20 8.08172 20 12.5V12.6455C21.4457 13.0758 22.5 14.4145 22.5 16C22.5 17.933 20.933 19.5 19 19.5C17.067 19.5 15.5 17.933 15.5 16C15.5 14.4145 16.5543 13.0758 18 12.6455V12.5C18 9.18629 15.3137 6.5 12 6.5C8.68629 6.5 6 9.18629 6 12.5V12.6455C7.44566 13.0758 8.5 14.4145 8.5 16C8.5 17.933 6.933 19.5 5 19.5C3.067 19.5 1.5 17.933 1.5 16C1.5 14.4145 2.55434 13.0758 4 12.6455V12.5C4 8.08172 7.58172 4.5 12 4.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBridge;
